import { useDispatch } from "react-redux";
import { nextStep } from './formSlice';
import {  sendToProlong } from "../home/homeApi";
import { useState } from "react";

import {  list_month } from "../../static/vars";
import { FioSuggestions } from "react-dadata";
import { InputMask } from "primereact/inputmask";

export function StepOneP(props) {
    const dispatch = useDispatch();


    const [name, setName] = useState();
    const [phone, setPhone] = useState();
    const [showDropDownMonth, setShowDropDownMonth] = useState(false);
    const [idMonth, setIdMonth] = useState('1');

    const handleShowDropDownMonth = () => {
        setShowDropDownMonth(!showDropDownMonth)
    }

    const handleSendProlong = () => {
        const inp = document.getElementById('name')
        let name_send = name || inp.value
        sendToProlong({
            name: name_send,
            phone: phone,
            month: list_month.find(x => x.value === idMonth).label
        }, function(data) {
            // dispatch(setStep(0))
            dispatch(nextStep())
        })
    }

    const handleChangeName = (e) => {
        setName(e.value)
    }

    const handleChangePhone = (e) => {
        setPhone(e.target.value)
    }

    
    function handleClickMonth(value) {
        setIdMonth(value)
        setShowDropDownMonth(false)
    }

    return (
        <div className="one-ekran-contant-lending-step one-ekran-contant-lending-step-2" style={{display: 'block'}}>
            <p className="lending-step-text">Заполни форму и получи 3% дополнительной скидки.<br/>Ваша страховка будет продлена вовремя!</p>
            <form className="form-popup form-popup-2">
                <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-13">
                    <label for="select-1">Ваше имя</label>
                    {/* <input className="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Имя" type="text" placeholder="-" required="" 
                        value={name}
                        onChange={handleChangeName}
                    /> */}
                    <FioSuggestions
                                        inputProps={{
                                            className: "pole-popup pole-popup-user pole-popup-1 pole-popup-00",
                                            id: 'name'
                                        }}
                                        defaultQuery={name}
                                        token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                        value={name}
                                        onChange={handleChangeName} />
                </div>
                <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-13">
                    <label for="select-1">Телефон</label>
                    {/* <input className="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Адрес" type="text" placeholder="+7" required="" 
                        value={phone}
                        onChange={handleChangePhone}
                    /> */}
                    <InputMask mask="+7(999) 999-9999"
                                        placeholder="+7(___) ___-____"
                                        className="pole-popup pole-popup-user pole-popup-1 pole-popup-00 mask-phone "
                                        value={phone}
                                        onChange={handleChangePhone}
                                    />
                </div>
                <div className="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-14 p-10">
                        <div className="form-group">
                            <div className="dropdown">
                                <label htmlFor="select-1">Месяц прдления страховки</label>
                                <div onClick={handleShowDropDownMonth} className="dropdown__button dropdown__button-popup dropdown__button-popup-user month">{list_month.find(x => x.value === idMonth).label}</div>
                                
                                <input type="text" name="select-category" defaultValue="" className="dropdown__input-hidden" />
                            </div>
                        </div>
                        {showDropDownMonth &&
                                    <ul className="dropdown__list over_scroll_y">
                                        {
                                            list_month.map((month, index) => {
                                                return (
                                                    <li key={index}
                                                        class="dropdown__list-item"
                                                        onClick={() => handleClickMonth(month.value)}
                                                    >
                                                        {month?.label}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }
                </div>
                <div className="checkbox-1-3-box">
                    <input className="checkbox-1 checkbox-1-3" type="checkbox" id="scales" name="zakon" defaultValue="" defaultChecked="" />
                    <label for="scales">Принимаю правила страхования</label>
                </div>
                <div onClick={handleSendProlong} className="button button-1 button-popup-1 button-lending-2">Отправить</div>
            </form>
        </div>
    )
}